import { FormValues } from './models/form-values';
import { ResultCallback } from './types/result-callback.type';
import { UniqueHtmlElement } from './unique-html-element';

export class FormHandler extends UniqueHtmlElement<HTMLFormElement> {
  getValues(): FormValues {
    const result = FormValues.blank();
    const formElements = this.element?.querySelectorAll<
      HTMLInputElement | HTMLSelectElement
    >('input,select');

    if (!formElements) {
      throw new Error('unable to extract form values');
    }

    for (const { name, value } of formElements) {
      const defaultValueType = typeof result[name];
      const normalizedValue =
        defaultValueType === 'number' ? parseFloat(value) : value;
      result[name] = normalizedValue;
    }

    return result;
  }

  onSubmit(callback: (e: SubmitEvent) => void) {
    this.element?.addEventListener('submit', e => {
      e.preventDefault();
      callback(e);
    });
  }

  subscribeToChanges(
    callback: ResultCallback<{
      name: keyof FormValues;
      value: FormValues[keyof FormValues];
    }>,
    ...targets: (keyof FormValues)[]
  ) {
    this.onChange(e => {
      if (targets.includes(e.name)) {
        callback(e);
      }
    });
  }

  private onChange(
    callback: ResultCallback<{
      name: keyof FormValues;
      value: FormValues[keyof FormValues];
    }>,
  ) {
    this.element?.addEventListener('input', e =>
      callback({
        name: (e.target as HTMLInputElement | HTMLSelectElement)
          ?.name as unknown as keyof FormValues,
        value: (e.target as HTMLInputElement | HTMLSelectElement)?.value,
      }),
    );
  }
}
